import FBIHttp from "./FBIHttp";

export interface defaul {
  content:{
    paineis:PainelOutput[],
  }
}

export interface PainelOutput {
  codigo: string,
  nome: string,
  id:string
}

class PainelService {
  private static readonly baseUrl = '/api/bi/Paineis';

  public static obterListaDePaineisPorModulo = async (modulo?: string | null): Promise<defaul> => FBIHttp.get(`${this.baseUrl}/${modulo}`);
}

export default PainelService;